import { messages } from "../../constants";

const fn = (intl) => [
  { value: "Vancouver", label: intl.formatMessage(messages.cities.vancouver) },
  { value: "Montreal", label: intl.formatMessage(messages.cities.montreal) },
  { value: "Toronto", label: intl.formatMessage(messages.cities.toronto) }
];

export default fn;
